import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { validate, validators } from 'validate-redux-form';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
} from "../../Utils/renderField/renderField";

function AgenteForm(props) {
    const { registroAgente, crear, modulo, modificarAgente,
        detallePais  } = props;
    
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar agente' : 'Crear agente';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver agente'
    }
    
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <div className="py-1">
                <br />
                <div className="mb-4 card card-small text-white bg-dark mb-3">
                    <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                        <div className="d-flex flex-column flex-1 mx-4">
                            <div className='mb-2 row'>
                                <div className='col-6'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="nombre_agente"
                                        placeholder="Nombre agente"
                                        className="form-control"
                                        component={renderField}
                                        disabled={disabled}
                                        msj="Nombre agente"
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {(crear === true) &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => { registroAgente(detallePais); }}
                                    >
                                        Guardar
                                    </button>
                                }
                                {(editar === true) &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => { modificarAgente(); }}
                                    >
                                        Modificar
                                    </button>
                                }
                                <a
                                    href={`/#/registro_marca/${id_emp[5]}/agente`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

AgenteForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormAgenteRM',
    validate: (data) => {
        return validate(data, {
            nombre_agente: validators.exists()('Este campo es requerido'),
        });
    },
    
})(AgenteForm);
